import { createSelector } from '@reduxjs/toolkit'
import { sortCheckpointableEntities } from '../../../helpers/sortCheckpointableEntities'
import {
  getPendingAssignmentsIds,
  getPendingPhaseItemsIds,
} from '../../getters/entities/approvalIds'
import { NormalizedApproval } from '../types'
import { selectNormalizedApprovals } from './normalizedApprovals'

const selectPendingAssignmentIds = createSelector(
  [getPendingAssignmentsIds],
  (pendingAssignmentIds) => pendingAssignmentIds || []
)

const selectPendingPhaseItemIds = createSelector(
  [getPendingPhaseItemsIds],
  (pendingPhaseItemIds) => pendingPhaseItemIds || []
)

export const selectPendingApprovals = createSelector(
  [
    selectNormalizedApprovals,
    selectPendingAssignmentIds,
    selectPendingPhaseItemIds,
  ],
  (normalizedApprovals, pendingAssignmentIds, pendingPhaseItemIds) => {
    const phaseItems = pendingPhaseItemIds.map((id) =>
      normalizedApprovals.find(
        (approval) => approval.id === id && approval.entityType === 'phase_item'
      )
    )

    const assignments = pendingAssignmentIds.map((id) =>
      normalizedApprovals.find(
        (approval) => approval.id === id && approval.entityType === 'assignment'
      )
    )

    return sortCheckpointableEntities(
      [...phaseItems, ...assignments].filter(
        (approval): approval is NormalizedApproval => approval !== undefined
      )
    )
  }
)
